import { BellIcon } from "@chakra-ui/icons";
import {
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spinner,
  Text,
  useColorModeValue,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { useReadNotification } from "hooks/notifications";
import { useNotifications, useGetLastNotifications, useNotificationsDispatch } from "hooks/notifications";
import { ACTION_TYPE } from "hooks/notifications/reducer";
import React, { useEffect } from "react";
import pusher from "services/pusher";
import { useHistory } from 'react-router-dom';

const Notification = ({ onClick, data }) => {
  return (
    <MenuItem onClick={() => onClick(data.customer_id, data.relation)} backgroundColor={data.read_at == null ? "green.100" : ""}>
      <Flex direction="column">
        <Text maxWidth="280px" fontSize="md">Resultado disponível para {data.customer_name}</Text>
        <Text fontSize="sm">{new Date(data.created_at).toLocaleDateString('pt-BR', { hour: 'numeric', minute: 'numeric' })}</Text>
      </Flex>
    </MenuItem>
  );
};

const Notifications = ({ userId }) => {
  const history = useHistory();
  const { notifications } = useNotifications()
  const { isLoading } = useGetLastNotifications();
  const { mutateAsync: read } = useReadNotification();

  const dispatch = useNotificationsDispatch();

  const toast = useToast();

  const navbarIcon = useColorModeValue("white", "white");
  const unreadIcon = useColorModeValue("red.400", "red.400");

  useEffect(() => {
    const channel = pusher.subscribe(`private-user.${userId}`);
    channel.bind("new-result", (data) => {
      if(data.type == "new-result") {
        toast({
          title: "Novo resultado disponível.",
          status: "info",
          duration: 4000,
          isClosable: true,
        });
        // setNotifications([...notifications, data.payload]);
        dispatch({type: ACTION_TYPE.NEW_NOTIFICATION , data: data.payload})
      }
    });

    return () => {
      channel.unbind("new-result");
      const channel = pusher.subscribe(`private-user.${userId}`);
    };
  }, []);

  const readNotification = (customer_id, relation) => {
    dispatch({type: ACTION_TYPE.READ_NOTIFICATION , data: relation})
    read(relation);

    const path = `/sistema/cliente/${customer_id}`;
    history.push(path); 
  }

  const unreadNotification = notifications.some(notification => notification.read_at == null);

  if(isLoading)
    return <Spinner size="sm" color="white" />

  return (
    <Menu>
      <MenuButton>
        <BellIcon color={unreadNotification ? unreadIcon : navbarIcon} w="18px" h="18px" />
      </MenuButton>
      <MenuList p="16px 8px">
        <VStack maxHeight="200px" overflowY="auto">
            {
                notifications.length === 0
                    ? <Flex p={4}>
                        <Text fontSize="md">Não existem resultados recentes.</Text>
                    </Flex>
                    :
                notifications.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                  .map(not => <Notification onClick={readNotification} data={not} />
                  )
            }
        </VStack>
      </MenuList>
    </Menu>
  );
};

export default Notifications;
